var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinterA4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "17.0128mm",
    height: "15.6498mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 36 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1875252620064"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11 22l13 0 0 7 -13 0 0 -7zm-3 -1l0 4c-6,0 -5,2 -5,-14 0,-2 1,-2 2,-2l25 0c4,0 2,5 2,14 0,3 -2,2 -5,2 0,-8 2,-6 -17,-6 -2,0 -2,1 -2,2zm3 -18l13 0 0 2 -13 0 0 -2zm-3 -1l0 3c-10,0 -8,1 -8,17 0,6 4,5 8,5 0,7 -2,5 17,5 3,0 2,-2 2,-5 10,0 8,-1 8,-17 0,-6 -4,-5 -8,-5 0,-7 2,-5 -17,-5 -2,0 -2,1 -2,2z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#040303",
    x: 5,
    y: 11,
    width: 8,
    height: 3,
    rx: 1,
    ry: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterA4);
export default __webpack_public_path__ + "static/media/printerA4.a35b8cc00cc6929f6d6c7768f3a11e4f.svg";
export { ForwardRef as ReactComponent };